export const initialState = {
  pageTitle: 'BlockX Labs | Clients & Partners'
};

const clients = (state = initialState) => state;

export default clients;
